<template>
    <div class="info_team_show">
        <!--<i-row>-->
        <!--<i-col span="20" offset="2">-->
        <!--<i-carousel autoplay loop>-->
        <!--<i-carouselItem v-for="item in slideDate">-->
        <!--<div class="carousel"><img class="carousel_img" :src="url + item.path"/></div>-->
        <!--</i-carouselItem>-->
        <!--</i-carousel>-->
        <!--</i-col>-->
        <!--</i-row>-->
        <i-row class="margintop">
            <i-col span="8" offset="2">
                <div>
                    <em class="line-r" style="width: 100%;"></em><br>
                </div>
            </i-col>
            <i-col span="4" style="text-align: center">
                <span class="title_head">团队展示</span>
                <br/>
                <span class="lang_eng">TEAM SHOW</span>
            </i-col>
            <i-col span="8">
                <div>
                    <em class="line-l" style="width: 100%;"></em><br>
                </div>
            </i-col>
        </i-row>
        <i-row class="margintop" style="margin-bottom: 30px;">
            <i-col span="3" offset="3" class="verticalMenu">
                <i-menu active-name="team_show" style="text-align: center;width: 100%;" @on-select="routeTo">
                    <i-menuItem name="intro">
                        <i-icon type="md-document"/>
                        大赛简介<br>
                        INTRODUCTION
                    </i-menuItem>
                    <i-menuItem name="notice">
                        <i-icon type="md-chatbubbles"/>
                        参赛须知<br>
                        NOTES
                    </i-menuItem>
                    <i-menuItem name="arrange">
                        <i-icon type="ios-ribbon"/>
                        赛事安排<br>
                        TRAVEL
                    </i-menuItem>
                    <i-menuItem name="news">
                        <i-icon type="md-document"/>
                        大赛新闻<br>
                        NEWS
                    </i-menuItem>
                    <i-menuItem name="team_show">
                        <i-icon type="ios-people"/>
                        团队展示<br>
                        TEAM SHOWCASE
                    </i-menuItem>
                    <i-menuItem name="org">
                        <i-icon type="ios-contacts"/>
                        组织机构<br>
                        ORGANIZATION
                    </i-menuItem>
                    <i-menuItem name="contact">
                        <i-icon type="ios-chatboxes"/>
                        联系我们<br>
                        CONTACT US
                    </i-menuItem>
                </i-menu>
            </i-col>
            <i-col span="14">
                <i-row style="margin-bottom: 50px;">
                    <i-col span="8" offset="6">
                        <i-input v-model="sou.name" search enter-button placeholder="团队名称搜索" @on-search="souClick"/>
                    </i-col>
                </i-row>
                <i-row v-for="item in tableData" class="team_div">
                    <i-col span="6" offset="3">
                        <img class="team_img" :src="url + item.logo" alt="1" v-if="item.logo != null"><br/>
                    </i-col>
                    <i-col span="13">
                        <i-row class="team_row">
                            <i-col span="3">
                                队名:
                            </i-col>
                            <i-col span="18">
                                {{item.name}}<br/>
                            </i-col>
                        </i-row>
                        <i-row class="team_row">
                            <i-col span="3">
                                口号:
                            </i-col>
                            <i-col span="21" style="height: 30px">
                                {{item.slogan}}
                            </i-col>
                        </i-row>
                        <i-row class="team_row">
                            <i-col span="3">
                                队长:
                            </i-col>
                            <i-col span="8">
                                {{item.one_name}}<br/>
                            </i-col>
                            <i-col span="3">
                                成员数:
                            </i-col>
                            <i-col span="8">
                                {{item.number}}<br/>
                            </i-col>
                        </i-row>
                        <i-row class="team_row">
                            <i-col span="3">
                                学校:
                            </i-col>
                            <i-col span="18">
                                {{item.school}}<br/>
                            </i-col>
                        </i-row>
                        <i-row class="team_row">
                            <i-col span="3">
                                选题:
                            </i-col>
                            <i-col span="8">
                                {{topic_type[item.topic_id]}}<br/>
                            </i-col>
                            <i-col span="4">
                                成立时间:
                            </i-col>
                            <i-col span="8">
                                {{item.create_time|formatDate}}<br/>
                            </i-col>
                        </i-row>
                    </i-col>
                </i-row>

                <i-col span="15" offset="4">
                    <i-page :total="count" show-total :page-size="5" @on-change="pageChange"></i-page>
                </i-col>
            </i-col>
        </i-row>
    </div>
</template>

<script>
    import {
        Icon,
        Col,
        Row,
        Carousel,
        CarouselItem,
        Breadcrumb,
        BreadcrumbItem,
        Menu,
        MenuGroup,
        MenuItem,
        Page,
        Input
    } from 'iview';
    import {api_getData} from '../../api/carousel';
    import {api_getTable} from '../../api/personal/team';
    import {formatDate} from '../../api/date.js';
    import {aliyun} from '../../config';

    export default {
        name: '',
        components: {
            'i-col': Col,
            'i-row': Row,
            'i-icon': Icon,
            'i-carousel': Carousel,
            'i-carouselItem': CarouselItem,
            'i-breadcrumb': Breadcrumb,
            'i-breadcrumbItem': BreadcrumbItem,
            'i-menu': Menu,
            'i-menuGroup': MenuGroup,
            'i-menuItem': MenuItem,
            'i-page': Page,
            'i-input': Input
        },
        filters: {
            formatDate(time) {
                var date = new Date(time * 1000);
                return formatDate(date, 'yyyy-MM-dd hh:mm');
            },
        },
        data() {
            return {
                topic_type: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
                slideDate: [],
                url: aliyun,
                details: '',
                number: {
                    page: 1,
                    limit: 5,
                },
                sou: {
                    name: '',
                },
                count: 0,
                tableData: [],
            }
        },
        async created() {
            let _data = await api_getData('home');
            let res = _data.body;
            if (res.code === 0) {
                this.slideDate = res.data;
            }
        },
        mounted() {
            this.gettable(this.number, this.sou);
        },
        methods: {
            souClick() {
                this.gettable(this.number, this.sou);
            },
            routeTo(name) {
                this.$router.push({name: 'info_' + name, params: {ver_name: name}});
            },
            pageChange(page) {
                this.number.page = page;
                this.gettable(this.number, this.sou);
            },
            gettable(num, find) {
                let data = {};
                for (let key in find) {
                    if (find[key] !== '' && find[key] !== '全部') {
                        data[key] = find[key];
                    }
                }
                api_getTable(num, data).then(_data => {
                    let res = _data.body;
                    if (res.code === 0) {
                        // console.log(res.data)
                        this.tableData = res.data;
                        this.count = res.count;
                    } else {
                        this.$Message.error(res.msg);
                    }
                });
            },
        }
    }
</script>

<style lang="scss">
    .info_team_show {
        text-align: left;

        .font_600 {
            font-weight: 600;
        }

        .margin_8 {
            margin-top: 8px;
        }

        /*轮播图设置*/
        .carousel {
            .carousel_img {
                width: 100%;
                height: 100%;
            }
        }

        /*row间距设置*/
        .margintop {
            margin-top: 20px;
        }

        /*队伍*/
        .team_div {
            height: 190px;
        }

        .team_img {
            border-radius: 3px;
            margin-top: 15px;
            margin-left: 30px;
            height: 140px;
            width: 140px;
            -moz-box-shadow: 5px 5px 10px rgba(160, 112, 197, 0.35);
            border-style: outset;
            border-color: #d3bce8;
            -webkit-box-shadow: 5px 5px 10px rgba(160, 112, 197, 0.35);
            box-shadow: 3px 3px 8px rgba(160, 112, 197, 0.35);
        }

        .team_row {
            height: 30px;
            line-height: 30px;
            padding-left: 5px;
            color: white;
            margin-bottom: 4px;
            border-radius: 5px;
            background-color: rgba(153, 153, 204, 1);
        }

        /*菜单栏start*/
        .verticalMenu {
            .ivu-menu-light {
                background: #d9b2ff;
            }

            .ivu-menu {
                display: block;
                border-radius: 40px;
                overflow: hidden;
                color: #ffffff;
                font-size: 14px;
                position: relative;
            }

            .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
                padding: 14px 24px;
                position: relative;
                cursor: pointer;
                z-index: 1;
                transition: all .2s ease-in-out;
                border: 1px solid;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
                color: #ffffff;
                font-weight: 600;
                background: rgb(153, 51, 255);
                z-index: 2;
            }

            .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
                color: #3d2404;
                border-color: rgb(153, 51, 255);
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
                content: '';
                display: block;
                width: 2px;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                background: #e5ea20;
            }
        }

        /*菜单栏end*/

        /*小标题start*/
        .title_head {
            color: #9933CC;
            font-weight: 600;
            font-size: 18px;
        }

        .lang_eng {
            /*color: rgb(255,165,51);*/
            font-size: 16px;
        }

        /*小标题end*/

        /*长线*/
        .line-l::after, .line-r::after {
            content: '';
            position: absolute;
            right: -4px;
            top: -7px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            border: 1px solid #8d40ef;
        }

        .line-l, .line-r {
            position: absolute;
            /*left: 0;*/
            top: 28px;
            width: 100px;
            height: 1px;
            background: #8d40ef;
        }

        em {
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-family: 微软雅黑, "Microsoft YaHei";
            margin: 0px;
            padding: 0px;
            list-style: none;
        }

        .line-r {
            right: 0;
            left: initial;
        }

        .line-r::after {
            left: -5px;
            right: initial;
        }


    }
</style>
